export const glowUpQueryKeys = {
  // Themes
  themes: {
    all: ['themes'] as const,
    byId: (id: number) => ['themes', id] as const,
  },
  // Categories
  categories: {
    all: ['categories'] as const,
    byId: (id: number) => ['categories', id] as const,
    byTheme: (themeId: number) => ['categories', 'theme', themeId] as const,
  },
  // Exercises
  exercises: {
    all: ['exercises'] as const,
    byId: (id: number) => ['exercises', id] as const,
    byCategory: (categoryId: number) =>
      ['exercises', 'category', categoryId] as const,
  },
  // Objective Attributes
  objectiveAttributes: {
    all: ['objective-attributes'] as const,
    byId: (id: number) => ['objective-attributes', id] as const,
  },
  // Therapy Attributes
  therapyAttributes: {
    all: ['therapy-attributes'] as const,
    byId: (id: number) => ['therapy-attributes', id] as const,
  },
};
